import { IMG_URL } from '../configs/app-global';

export default function createImage(name) {
  return {
    name,
    url: IMG_URL + name,
  };
}
